import * as React from 'react'
import { SVGProps } from 'react'
const SvgSwap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 5a5 5 0 0 1 5-5h26a5 5 0 0 1 5 5v26a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z"
      fill="#F6F7F9"
    />
    <g clipPath="url(#Swap_svg__a)">
      <path
        d="M23.413 16.2h-8.628a.9.9 0 1 1 0-1.8h8.628l-1.464-1.464a.9.9 0 1 1 1.273-1.273l2.996 2.996.004.004a.897.897 0 0 1 0 1.273l-.002.002-2.998 2.998a.9.9 0 1 1-1.273-1.273l1.464-1.464Z"
        fill="#1B2736"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.537 19.736 13.073 21.2h8.628a.9.9 0 1 1 0 1.8h-8.628l1.464 1.464a.9.9 0 1 1-1.273 1.272l-2.998-2.997-.002-.003a.902.902 0 0 1 0-1.272l.004-.004 2.996-2.996a.9.9 0 1 1 1.273 1.272Z"
        fill="#00D37E"
      />
    </g>
    <defs>
      <clipPath id="Swap_svg__a">
        <path fill="#fff" transform="rotate(-90 18 9)" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgSwap
